var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/contentful/components/image-macro.j2"] = require( "macros/contentful/components/image-macro.j2" );
dependencies["contentful/shoppable/shoppable-product-component.j2"] = require( "contentful/shoppable/shoppable-product-component.j2" );
dependencies["contentful/shoppable/shoppable-product-indicator.j2"] = require( "contentful/shoppable/shoppable-product-indicator.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/shoppable/shoppable-image-component.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/contentful/components/image-macro.j2", false, "core/templates/contentful/shoppable/shoppable-image-component.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("buildImage")) {
var t_4 = t_1.buildImage;
} else {
cb(new Error("cannot import 'buildImage'")); return;
}
context.setVariable("buildImage", t_4);
output += "<div class=\"c-shoppable-image__skip-link-wrapper\">\n    <div class=\"c-shoppable-image__skip-link\" aria-hidden=\"false\" tabindex=\"0\">\n        ";
output += runtime.suppressValue((lineno = 4, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["shopitorial_skip-content-text"])), env.opts.autoescape);
output += "\n    </div>\n</div>\n\n<div class=\"c-shoppable-image__outer dom-shoppable-product\" tabindex=\"0\">\n    ";
frame = frame.push();
var t_7 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"components");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("component", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
var t_9;
t_9 = (lineno = 10, colno = 51, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.imageHasSecondaryImage"]));
frame.set("imageHasSecondaryImage", t_9, true);
if(frame.topLevel) {
context.setVariable("imageHasSecondaryImage", t_9);
}
if(frame.topLevel) {
context.addExport("imageHasSecondaryImage", t_9);
}
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((t_8),"sys")),"contentType")),"sys")),"id") == "componentShoppableProductTag") {
output += "\n            ";
var t_10;
t_10 = t_8;
frame.set("shoppableProduct", t_10, true);
if(frame.topLevel) {
context.setVariable("shoppableProduct", t_10);
}
if(frame.topLevel) {
context.addExport("shoppableProduct", t_10);
}
output += "\n            ";
env.getTemplate("contentful/shoppable/shoppable-product-component.j2", false, "core/templates/contentful/shoppable/shoppable-image-component.j2", null, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
t_11.render(context.getVariables(), frame, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
output += t_12
output += "\n        ";
})});
}
else {
output += "\n            ";
output += runtime.suppressValue((lineno = 16, colno = 23, runtime.callWrap(t_4, "buildImage", context, [t_8,runtime.makeKeywordArgs({"experience": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")})])), env.opts.autoescape);
output += "\n        ";
;
}
output += "\n    ";
;
}
}
frame = frame.pop();
output += "\n\n    ";
env.getTemplate("contentful/shoppable/shoppable-product-indicator.j2", false, "core/templates/contentful/shoppable/shoppable-image-component.j2", null, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
t_15.render(context.getVariables(), frame, function(t_18,t_16) {
if(t_18) { cb(t_18); return; }
output += t_16
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/shoppable/shoppable-image-component.j2"] , dependencies)